import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RidePlannerActions } from './+state/ride-planner.actions';
import { RidePlannerEpics } from './+state/ride-planner.epic';
import { RidePlannerFacade } from './+state/ride-planner.facade';
import { RidePlannerService } from './ride-planner.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [RidePlannerService, RidePlannerFacade, RidePlannerActions, RidePlannerEpics],
})
export class RidePlannerModule {}
